import {LicensePlateInput} from "../components";

const en = {
    system_catalog: "System catalog",
    help_search_detail:"Perhaps you meant",
    header_text: "Time Standards Motordata",
    login_info: "Not registered yet",
    load_text: "Search...",
    license_plate_error:"Incorrect license plate",
    license_plate_label:"Enter license plate number",
    license_plate_info:"License number",
};

export default en;